import React from "react";
// import { useTranslation } from "react-i18next";
// import { Link } from "react-router-dom";

const SmokingCessationAndScreening = () => {
  // const { t } = useTranslation();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          戒菸與低劑量電腦斷層篩檢
        </h1>
        <p className="text-xl text-gray-600 mb-12">
          了解戒菸的重要性，掌握肺癌早期篩檢的資訊
        </p>
      </div>

      {/* 戒菸指南區塊（可補充內容） */}
      <div className="bg-white rounded-xl shadow p-8 mb-12">
        <h2 className="text-2xl font-bold text-green-900 mb-4">🚭 戒菸</h2>
        <p className="text-lg text-gray-700 mb-4">
          很多人以為，年紀大了戒菸沒差，其實不然。**年紀越大，戒菸越重要！**以下這些抽菸帶來的問題，對年長者特別傷害大：
          <br />
          <br />
          <ul>
            <li>
              <strong>抽菸會讓腦袋退化更快。</strong>
              長期吸菸會讓血管變窄、血流變差，大腦就容易缺氧、神經細胞受損，長久下來容易導致失智。
            </li>
            <li>
              <strong>抽菸讓骨頭更容易脆掉。</strong>
              隨著年紀增長，骨質會慢慢流失，尤其是女性更年期後鈣質流失快，如果再加上抽菸，骨質疏鬆的風險更高，容易發生骨折、駝背、走路不穩。
            </li>
            <li>
              <strong>抽菸會讓血管硬化，加速中風和心臟病。</strong>
              像是脖子裡的頸動脈，一旦被菸害影響硬化，血流不順就可能導致腦中風。研究也證實，戒菸後這類風險會明顯降低。
            </li>
            <li>
              <strong>抽菸傷牙齒，會讓牙周病惡化。</strong>
              年紀大後本來牙齒就比較脆弱，抽菸又會讓牙齒周圍的組織更容易發炎、流膿、牙垢變多，進一步造成牙齒脫落。
            </li>
            <li>
              <strong>抽菸還會傷害眼睛。</strong>
              老年人本來就容易視力退化，但抽菸會加速「黃斑部病變」等問題，讓視力惡化更快。
            </li>
          </ul>
          <br />
          <span className="font-semibold text-green-800">戒菸小妙招：</span>
          <ul>
            <li>深呼吸 15 次，慢慢吸、慢慢吐。</li>
            <li>喝一大杯水，轉移注意力。</li>
            <li>起來伸展活動、散步、做些小運動。</li>
            <li>立刻去刷牙、洗臉，改變當下感覺。</li>
          </ul>
          <br />
          <span className="font-semibold text-green-800">戒菸的過程：</span>
          <ul>
            <li>未考慮期：還沒準備戒。</li>
            <li>考慮期：想戒，但還在想。</li>
            <li>準備期：已經在找方法，近期就要戒。</li>
            <li>行動期：正在戒菸中。</li>
            <li>維持期：已經戒菸超過半年。</li>
          </ul>
          <br />
          <span className="font-semibold text-green-800">
            為什麼戒菸會這麼難？
          </span>
          <ul>
            <li>
              因為菸裡的尼古丁會讓人上癮，一旦停止，身體會出現一些不舒服的反應，叫做「尼古丁戒斷症候群」：
            </li>
            <li>情緒變差、心情鬱悶</li>
            <li>睡不好、容易發脾氣</li>
            <li>焦慮、坐立難安</li>
            <li>食慾變好，甚至體重上升</li>
          </ul>
          <br />
          這些症狀大多在戒菸後的1~4天最明顯，2~4週會慢慢減輕。
          但請記得：這些都是暫時的。你可以用上述的小方法度過這段時間，也可以尋求醫師協助，有戒菸門診、貼片、藥物等幫助你更順利戒菸。
          <br />
          不要一個人撐，戒菸，你做得到！
          <br />
          <br />
          <span className="font-semibold text-green-800">📞實用戒菸資源：</span>
          <ul>
            <li>
              免費戒菸專線 0800-636363：全年無休，提供電話諮詢與心理支持。
              <br />
              <strong>Line ID：@tsh0800636363</strong>
            </li>
            <li>
              戒菸門診（臺大醫院系統）：
              <a
                href="https://www.ylh.gov.tw/?aid=61&pid=106"
                className="text-blue-600 underline break-all"
              >
                https://www.ylh.gov.tw/?aid=61&pid=106
              </a>
            </li>
            <li>
              無菸專區：
              <a
                href="https://www.ylh.gov.tw/?aid=60&pid=106"
                className="text-blue-600 underline break-all"
              >
                https://www.ylh.gov.tw/?aid=60&pid=106
              </a>
            </li>
            <li>
              國健署戒菸手冊：
              <a
                href="https://www.hpa.gov.tw/Pages/EBook.aspx?nodeid=1172"
                className="text-blue-600 underline break-all"
              >
                https://www.hpa.gov.tw/Pages/EBook.aspx?nodeid=1172
              </a>
            </li>
          </ul>
        </p>
      </div>

      {/* 肺癌篩檢區塊 */}
      <div className="">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">🔍 肺癌篩檢</h2>
        <div className="space-y-6">
          <div className="bg-white rounded-xl shadow p-5">
            <div className="font-bold text-lg mb-2 text-green-800">
              📌 1. 美國國家肺癌篩檢試驗（NLST, 2011）
            </div>
            <div className="text-gray-700 mb-2">
              這是全球第一個證實低劑量電腦斷層有效減少肺癌死亡率的大型臨床試驗。研究招募了超過
              5 萬名高風險族群（年齡 55–74 歲、重度吸菸者），比較低劑量電腦斷層
              和傳統胸部 X 光的篩檢效果。結果發現，低劑量電腦斷層能降低 20%
              的肺癌死亡率，顯示出早期偵測肺癌對於存活率有明顯幫助，這也成為全球肺癌篩檢政策的里程碑
            </div>
            <a
              href="https://pubmed.ncbi.nlm.nih.gov/21714641/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline break-words"
            >
              PubMed - NLST Study
            </a>
          </div>
          <div className="bg-white rounded-xl shadow p-5">
            <div className="font-bold text-lg mb-2 text-green-800">
              📌 2. 「非吸菸者」的低劑量電腦斷層前瞻性研究（2022）
            </div>
            <div className="text-gray-700 mb-2">
              這項研究由台灣團隊執行，針對從未吸菸、但具有肺癌家族史的民眾進行
              LDCT
              篩檢，發現即便沒有抽菸，只要有家族病史，也屬於高風險族群，應考慮接受早期篩檢。研究也指出，這群人中女性比例較高，且常於早期即發現肺癌病灶，因此建議女性有家族史者應更積極接受篩檢。
            </div>
            <a
              href="https://pubmed.ncbi.nlm.nih.gov/35307337/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline break-words"
            >
              PubMed - Taiwan Never-Smoker Study
            </a>
          </div>
          <div className="bg-white rounded-xl shadow p-5">
            <div className="font-bold text-lg mb-2 text-green-800">
              📌 3. 真實世界研究：「Stage Shift Improves Lung Cancer
              Survival」分析（2022）
            </div>
            <div className="text-gray-700 mb-2">
              研究利用實際臨床數據，證實 LDCT 能將肺癌診斷的期別「由晚轉早」（即
              stage
              shift），而這樣的階段轉移與顯著提高的整體存活率有直接關聯。研究強調，LDCT
              不僅發現更多早期肺癌，還進一步提升治療成功率與降低死亡率，是推動全民肺癌篩檢的重要依據。
            </div>
            <a
              href="https://doi.org/10.1016/j.jtho.2022.09.005"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline break-words"
            >
              Journal of Thoracic Oncology - Stage Shift Study
            </a>
          </div>
        </div>
        <div className="bg-white rounded-2xl shadow-lg p-8 mt-8">
          <div className="font-bold text-2xl text-gray-900 mb-4">
            低劑量電腦斷層篩檢政策：
          </div>
          <ul>
            <li>
              具肺癌家族史：40至74歲女性或45至74歲男性，且其有血緣關係之父母、子女或兄弟姊妹經診斷為肺癌之民眾。若有吸菸情形，應同意接受戒菸服務。
            </li>
            <li>
              重度吸菸者：50至74歲吸菸史達20包-年，仍在吸菸或戒菸未達15年之重度吸菸者。若有吸菸情形，應同意接受戒菸服務。
            </li>
          </ul>
          {/* <ul className="list-disc pl-6 text-lg text-gray-900 space-y-2 mb-4">
            <li>
              <span className="font-semibold text-green-800">
                有肺癌家族史：
              </span>
              <ul className="list-disc pl-6">
                <li>男性：45～74 歲</li>
                <li>女性：40～74 歲</li>
                <li>爸爸、媽媽、兄弟姊妹、兒女得過肺癌即符合</li>
              </ul>
            </li>
            <li>
              <span className="font-semibold text-green-800">重度抽菸者：</span>
              <ul className="list-disc pl-6">
                <li>年齡 50～74 歲</li>
                <li>抽菸達 20 包年（如一天 1 包抽 20 年）</li>
                <li>還在抽，或戒菸未滿 15 年</li>
              </ul>
            </li>
          </ul> */}
          {/* <div className="mt-2 text-green-900 font-medium text-base">
            這項檢查可提早發現與治療肺癌，提升存活率、降低死亡率，是政府推動的重要健康政策。
          </div> */}
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8 mt-8">
          <span>資料來源：</span>
          <ul className="list-disc pl-6 space-y-2 pt-2">
            <li>
              <a
                href="https://www.ylh.gov.tw/?aid=60&pid=106"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 underline break-words"
              >
                無菸專區
              </a>
            </li>
            <li>
              <a
                href="https://pubmed.ncbi.nlm.nih.gov/21714641/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 underline break-words"
              >
                National Lung Screening Trial Research Team. (2011). Reduced
                lung-cancer mortality with low-dose computed tomographic
                screening. The New England Journal of Medicine, 365(5), 395–409.
              </a>
            </li>
            <li>
              <a
                href="https://pubmed.ncbi.nlm.nih.gov/35307337/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 underline break-words"
              >
                Hsu, H.-H., et al. (2022). Low-dose computed tomography
                screening for lung cancer in never-smokers and current smokers:
                A population-based study in Taiwan. JAMA Oncology, 8(5),
                673–681.
              </a>
            </li>
            <li>
              <a
                href="https://doi.org/10.1016/j.jtho.2022.09.005"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 underline break-words"
              >
                Tong, B. C., Kosinski, A. S., Yang, C.-J., Harpole, D. H., &
                Detterbeck, F. C. (2023). Lung cancer screening leads to stage
                shift and improved survival in real-world practice. Journal of
                Thoracic Oncology, 18(2), 180–190.
              </a>
            </li>
            <li>
              <a
                href="https://www.hpa.gov.tw/Pages/List.aspx?nodeid=4619"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 underline break-words"
              >
                衛生福利部，國民健康署
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SmokingCessationAndScreening;
